import axios from 'CanExConfig/axios'

export const searchCompanies = async term => {
  const response = await axios('/search/companies', {
    method: 'GET',
    params: {
      term,
    },
  })
  return response.data
}
